import styled from "styled-components";
import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import { CSSProperties, FC, ReactNode } from "react";
import { MOBILE_MENU } from "common/constants";
import useMedia from "utils/hooks/useMedia";
import { typography } from "@shared/common/Themes/typography";

interface StatisticProps {
  title: string;
  value: ReactNode;
  icon?: ReactNode;
  bordered?: Boolean;
  style?: CSSProperties;
  className?: string;
  baseSize?: string;
}

const Statistic: FC<StatisticProps> = ({
  title,
  value,
  icon,
  bordered,
  style,
  className,
  baseSize = typography.fontSizes.L,
}) => {
  const isMobile = useMedia([`(max-width: 430px)`], [true], false);

  return (
    <Wrapper $bordered={Boolean(bordered)} style={style} className={className}>
      <Title type={"secondary"} level={isMobile ? 5 : 4}>
        {title}
      </Title>
      <Text
        as={"div"}
        $weight={typography.fontWeights.MEDIUM}
        $size={isMobile ? typography.fontSizes.M : baseSize}
      >
        {icon}
        <ValueWrapper $marginLeft={icon ? 6 : 0}>{value}</ValueWrapper>
      </Text>
    </Wrapper>
  );
};

export default Statistic;

const Wrapper = styled.div<{ $bordered: boolean }>`
  display: flex;
  align-items: center;
  flex-flow: column;
  margin-bottom: 10px;
  transition: 0.35s border;
  white-space: nowrap;
  ${(p) =>
    p.$bordered &&
    `
    border: ${p.theme.borders.lightest};
    border-radius: 8px;
    padding: 8px 20px;
  `}
`;
const ValueWrapper = styled.div<{ $marginLeft: number }>`
  @media (max-width: ${MOBILE_MENU}) {
    font-size: ${(p) => p.theme.typography.fontSizes.L}px;
  }

  ${(p) =>
    p.$marginLeft &&
    `
    margin-left: ${p.$marginLeft}px;
  `}
`;
